import { type ReactElement, useEffect, useState } from 'react';

export function TumbleWord({
  tumbleWords,
  leadSentence,
  inline,
}: {
  leadSentence: string | ReactElement;
  inline: boolean;
  tumbleWords: string[];
}) {
  const [prevWordIndex, setPrevWordIndex] = useState<number | null>(null);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  // Find the longest word to set a fixed width
  const longestWord = tumbleWords.reduce((a, b) =>
    a.length > b.length ? a : b
  );

  // Rotate through words
  useEffect(() => {
    const interval = setInterval(() => {
      setPrevWordIndex(currentWordIndex);
      setCurrentWordIndex((prev) => (prev + 1) % tumbleWords.length);
    }, 3000); // Change word every 3 seconds

    return () => clearInterval(interval);
  }, [currentWordIndex, tumbleWords.length]);

  return (
    <>
      {leadSentence}{' '}
      <span className="inline-block relative align-bottom h-[1em] overflow-visible px-1 text-orange">
        {/* Invisible placeholder sized to the CURRENT word */}
        <span className="invisible whitespace-nowrap">
          {inline ? longestWord : tumbleWords[currentWordIndex]}
        </span>

        {prevWordIndex !== null && (
          <span
            className={`absolute inset-x-0 bottom-0 flex ${inline ? 'justify-start' : 'justify-center'}`}
          >
            <span
              key={`out-${prevWordIndex}`}
              className="whitespace-nowrap animate-[tumbleOut_0.6s_ease-in-out_forwards]"
            >
              {tumbleWords[prevWordIndex]}
            </span>
          </span>
        )}

        <span
          className={`absolute inset-x-0 bottom-0 flex ${inline ? 'justify-start' : 'justify-center'}`}
        >
          <span
            key={`in-${currentWordIndex}`}
            className="whitespace-nowrap animate-[tumbleIn_0.6s_ease-in-out_forwards]"
          >
            {tumbleWords[currentWordIndex]}
          </span>
        </span>
      </span>
    </>
  );
}

export function EveryBodyTumbleWord({
  leadSentence = (
    <>
      Bulk Nutrients is for <br />
    </>
  ),
  inline = false,
  tumbleWords = [
    'every body',
    'every lift',
    'every adventure',
    'every step',
    'every recovery',
  ],
}: {
  leadSentence?: string | ReactElement;
  inline?: boolean;
  tumbleWords?: string[];
}) {
  return (
    <TumbleWord
      tumbleWords={tumbleWords}
      leadSentence={leadSentence}
      inline={inline}
    />
  );
}
